<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper login-body">
    <div class="login-wrapper">
      <div class="container">
        <img
          class="img-fluid logo-dark mb-2"
          src="@/assets/img/logo2.png"
          alt="Logo"
        />
        <div class="loginbox">
          <div class="login-right">
            <div class="login-right-wrap">
              <h1>Reset Password</h1>
              <p class="account-subtitle">
                Enter the token sent to your email and your new password
              </p>

              <Form
                class="login"
                @submit="onSubmit"
                :validation-schema="schema"
                v-slot="{ errors }"
              >
                <div class="form-group">
                  <label class="form-control-label">Password</label>
                  <span class="text-danger">*</span>
                  <div class="pass-group">
                    <Field
                      name="password"
                      :type="showPassword ? 'password' : 'text'"
                      v-model="form.password"
                      class="form-control pass-input mt-2"
                      :class="{ 'is-invalid': errors.password }"
                    />
                    <span
                      v-if="!errors.password"
                      @click="toggleShow"
                      class="fas toggle-password"
                      :class="{
                        'fa-eye': showPassword,
                        'fa-eye-slash': !showPassword,
                      }"
                    ></span>
                    <div class="invalid-feedback">{{ errors.password }}</div>
                    <div class="emailshow text-danger" id="password"></div>
                  </div>
                </div>
                <div class="form-group">
                  <label class="form-control-label">Confirm Password</label>
                  <span class="text-danger">*</span>
                  <div class="pass-group">
                    <Field
                      name="confirmpassword"
                      :type="showConfirmPassword ? 'password' : 'text'"
                      class="form-control pass-input mt-2"
                      :class="{ 'is-invalid': errors.confirmpassword }"
                    />
                    <span
                      v-if="!errors.confirmpassword"
                      @click="toggleConfirmShow"
                      class="fas toggle-password"
                      :class="{
                        'fa-eye': showConfirmPassword,
                        'fa-eye-slash': !showConfirmPassword,
                      }"
                    ></span>
                    <div class="invalid-feedback">
                      {{ errors.confirmpassword }}
                    </div>
                    <div
                      class="emailshow text-danger"
                      id="confirmpassword"
                    ></div>
                  </div>
                </div>
                <button
                  class="btn btn-lg btn-block btn-primary w-100"
                  type="submit"
                  :disabled="isLoading"
                >
                  <span
                    v-if="isLoading"
                    class="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span v-if="!isLoading">Reset Password</span>
                  <span v-if="isLoading">Loading...</span>
                </button>
                <!-- /Social Login -->
                <div class="text-center dont-have">
                  Remembered your password?
                  <router-link :to="{ name: 'login' }">Login</router-link>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Main Wrapper -->
</template>
<script setup>
import { ref } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { Form, Field } from "vee-validate";
import * as Yup from "yup";

const store = useStore();
const showPassword = ref(true);
const showConfirmPassword = ref(true);
const isLoading = ref(false);
const route = useRoute();

const form = ref({
  token: route.query.token || "",
  email: route.query.email || "",
  password: "",
});

const toggleShow = () => {
  showPassword.value = !showPassword.value;
};
const toggleConfirmShow = () => {
  showConfirmPassword.value = !showConfirmPassword.value;
};

const schema = Yup.object().shape({
  password: Yup.string()
    .min(8, "Password must be at least 8 characters")
    .required("Password is required"),
  confirmpassword: Yup.string()
    .min(8, "Password must be at least 8 characters")
    .required("Confirm password is required")
    .oneOf([Yup.ref("password")], "Passwords do not match"),
});

const onSubmit = () => {
  isLoading.value = true;
  store
    .dispatch("auth/resetPassword", form.value)
    .then(() => {
      isLoading.value = false;
    })
    .catch(() => {
      isLoading.value = false;
    });
};
</script>
